import { useQuery } from "@tanstack/react-query";
import { getPrescriptionDetail } from "../services/eprescriptionDetailService";

export const usePrescriptionDetail = (
  prescriptionId?: string,
  token?: string | null
) => {
  return useQuery({
    queryKey: ["prescription-detail", prescriptionId],
    queryFn: () => getPrescriptionDetail(prescriptionId!, token!),
    enabled: !!prescriptionId && !!token,
    staleTime: 0,
    refetchInterval: 10000,
    refetchOnWindowFocus: true,
  });
};